<template>
  <easy-page-template
      title="システムに関して、何を行いますか？"
      subtitle="システムに関して行うことを、以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconSystemImplementation"
          title="実装を管理する"
          to="/easy/systemHome/implementation"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconSystemDictionary"
          title="辞書を管理する"
          to="/easy/systemHome/dictionary"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconSystemTerminal"
          title="サイトを管理する"
          to="/easy/systemHome/terminal"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import iconSystemImplementation from "./assets/icon_system_implementation.svg";
import iconSystemDictionary from "./assets/icon_system_dictionary.svg";
import iconSystemTerminal from "./assets/icon_system_terminal.svg";
import imageTradeContract from "./assets/image_trade_contract.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";

export default {
  name: "SystemHome",
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      iconSystemImplementation,
      iconSystemDictionary,
      iconSystemTerminal,
      imageTradeContract
    }
  }
}
</script>

<style scoped>

</style>
